'use client';
import { createTheme, type ThemeOptions } from '@mui/material/styles';
import siteConfig from '@/config/site';

/**
 * Theme derived from config/site brand colours. Edit brand values there,
 * not here, so the whole look-and-feel is configured in one place.
 */
const base: ThemeOptions = {
  palette: {
    mode: siteConfig.brand.mode,
    primary: { main: siteConfig.brand.primary },
    secondary: { main: siteConfig.brand.secondary },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: 'var(--font-roboto), system-ui, -apple-system, sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.01em' },
    h3: { fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 999 } },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 16 } },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0, color: 'inherit' },
    },
  },
};

export const theme = createTheme(base);
export default theme;
